/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface RecreateHasuraSchema200Response
 */
export interface RecreateHasuraSchema200Response {
    /**
     * 
     */
    message?: string;
    /**
     * 
     */
    instancesUpdated?: number;
}

/**
 * Check if a given object implements the RecreateHasuraSchema200Response interface.
 */
export function instanceOfRecreateHasuraSchema200Response(value: object): value is RecreateHasuraSchema200Response {
    return true;
}

export function RecreateHasuraSchema200ResponseFromJSON(json: any): RecreateHasuraSchema200Response {
    return RecreateHasuraSchema200ResponseFromJSONTyped(json, false);
}

export function RecreateHasuraSchema200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecreateHasuraSchema200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'instancesUpdated': json['instancesUpdated'] == null ? undefined : json['instancesUpdated'],
    };
}

export function RecreateHasuraSchema200ResponseToJSON(json: any): RecreateHasuraSchema200Response {
    return RecreateHasuraSchema200ResponseToJSONTyped(json, false);
}

export function RecreateHasuraSchema200ResponseToJSONTyped(value?: RecreateHasuraSchema200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'instancesUpdated': value['instancesUpdated'],
    };
}

